/**
 * Resolve the analytics-api-service base URL for the current environment.
 *
 * Priority:
 *   1. REACT_APP_ANALYTICS_API_URL env var override (set per build / per `.env`).
 *   2. Window hostname-based mapping:
 *        - web.mypatientspace.com         → prod analytics  (mps-analytics-prod-eu)
 *        - preprod / test / uat / any
 *          *.mypatientspace.com host       → preprod analytics (mps-analytics-v2)
 *   3. Local dev (no env var, non-MPS hostname) → http://localhost:3000.
 *
 * Mirrors the env-aware fallback used by kpiService.js but exposed as a
 * shared helper so chat services (chatSocketService, chatSummaryService)
 * don't fall back to a bare http://localhost:3000 on hosted builds when
 * REACT_APP_ANALYTICS_API_URL isn't set — which was producing
 * `POST http://localhost:3000/api/chat/sessions/summary net::ERR_FAILED`.
 */
export function getAnalyticsApiBase() {
  if (process.env.REACT_APP_ANALYTICS_API_URL) {
    return process.env.REACT_APP_ANALYTICS_API_URL;
  }
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host === "web.mypatientspace.com") {
      return "https://mps-analytics-prod-eu.azurewebsites.net";
    }
    if (host.endsWith(".mypatientspace.com")) {
      return "https://mps-analytics-v2.azurewebsites.net";
    }
  }
  return "http://localhost:3000";
}

export default getAnalyticsApiBase;
